import React from 'react';
import { motion } from 'framer-motion';
import { JasonTestimonial } from '../components/landing/JasonTestimonial';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HeroSection } from '../components/landing/HeroSection';

export const JasonPage: React.FC = () => {
  return (
    <div className="space-y-24">
      <JasonTestimonial />
      <HeroSection />
      <div className="mt-24">
        <FeaturesSection />
      </div>
    </div>
  );
};